import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../Shared/colors";
import { NavLink, useMatch } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TaskIcon from "@mui/icons-material/Task";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotificationsIcon from "@mui/icons-material/Notifications";
import StarRateIcon from "@mui/icons-material/StarRate";
import ShareIcon from "@mui/icons-material/Share";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ForumIcon from "@mui/icons-material/Forum";
import { subscribeToNotifications } from "../../services/socket";
import CryptoJS from "crypto-js";
import { decryptData } from "../../services/crypto";
import { MainContainer, Section } from "./sharedSidebarStyles";
import { canSeeSocialLeads } from "../../Shared/roleAccess";


export const LeadsSidebar = () => {

  // let user = JSON.parse(localStorage.getItem("user"));
  let role = null;
  const Role = localStorage.getItem("role");
  let user = null;
  const storedData = localStorage.getItem("user");
  
  if (storedData) {
    try {
      user = decryptData(storedData);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
   if (Role) {
    try {
      role = decryptData(Role);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
console.log(role)
  return (
    <>
    <MainContainer>
      <Section>
        <p>Leads</p>
        <div>
          <NavLink end to="leads">
            <SearchOutlinedIcon /> <span>Search Leads</span>
          </NavLink>
          <NavLink end to="leads/favourite">
            <StarRateIcon />
            <span>Favourite Leads</span>
          </NavLink>
          {role !== "ts" && (
          <NavLink end to="leads/shared">
            <ShareIcon />
            <span>Shared Leads</span>
          </NavLink>
          )}
          <NavLink end to="leads/todolist">
            <TaskIcon />
            <span>Todo List</span>
          </NavLink>
          {role !== "ts" && (
          <NavLink end to="leads/cmp">
            <AccountTreeIcon />
            <span>CMP</span>
          </NavLink>
          )}
          {role !== "ts" && (
          <NavLink end to="leads/addnewleads">
            <ControlPointIcon />
            <span>Add New Leads</span>
          </NavLink>
          )}
          <NavLink end to="leads/manageleads">
            <SettingsBackupRestoreIcon />
            <span>Manage Leads</span>
          </NavLink>
          <NavLink end to="leads/calendar">
            <CalendarMonthIcon />
            <span>Calendar</span>
          </NavLink>
          {canSeeSocialLeads(role) && (
          <NavLink end to="leads/social-media">
            <ForumIcon />
            <span>Social Media</span>
          </NavLink>
          )}
        </div>
      </Section>
      <Section>
        <p>Others</p>
        <div>
          <NavLink end to="leads/notifications">
             <NotificationsIcon />
            <span>Notifications</span>
          </NavLink>
        </div>
      </Section>
       </MainContainer>

       
    </>
  );
};


// Styled components are now imported from sharedSidebarStyles.js

// const MainContainer = styled.div`
//   height: 100%; 
//   overflow-y: auto; 
//   scrollbar-width: none;
//  -ms-overflow-style: none;

//   ::-webkit-scrollbar {
//     display: none;
//   }
 
// `;


// const Section = styled.div`
// display: flex;
// flex-direction: column;
// p{
//     color: ${colors.textLight};
//     font-size: clamp(0.9em,0.9vh,2em);
//     margin-top: 1em;
// }
// div{
//     display: flex;
//     flex-direction: column;
//     a {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-decoration: none;
//   color: ${colors.textMed};
//   width: 100%;
//   padding: 1em 0;
//   font-size: clamp(1em, 1vh, 2em);
//   margin-top: 1em;
//   border-radius: 5px;
//   transition: all 0.3s ease-out;
//   position: relative;

//   /* Add pseudo-element for the left border */
//   ::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 0;
//     height: 100%;
//     width: 5px; /* Width of the left border */
//     background-color: ${colors.brown}; /* Left border color */
//     border-radius: 5px 0 0 5px; /* Smooth rounded edge on the left */
//     display: none; /* Hidden by default */
//   }

//   :hover {
//     background-color: ${colors.inputWhite};
//     color: ${colors.brown};

//     /* Show the left border on hover */
//     ::before {
//       display: block;
//     }
//   }

//   &.active {
//     background-color: ${colors.inputWhite};
//     color: ${colors.brown};

//     /* Show the left border for active state */
//     ::before {
//       display: block;
//     }
//   }
// }
//         span{
//             width: 50%;
//             margin-left: 5%;
//         }
//     }
//     .active{
//             background-color: ${colors.inputWhite};
//             color: ${colors.brown};
//             ::before{
//                 display: block;
//             }
//         }
// }
// `